import type { IconLoaders } from "../types";

/** Everyday things: calendar, user, money */
export const objectIcons = {
    bank_outline: () => import("./bank_outline"),
    briefcase: () => import("./briefcase"),
    calendar: () => import("./calendar"),
    list_bullet: () => import("./list_bullet"),
    money: () => import("./money"),
    split_payment: () => import("./split_payment"),
    user: () => import("./user"),
} satisfies IconLoaders;
